import './Styles/translate.css'
function TranslateBox() {

    function changeLang(event) {
        var lang = event.target.value;
        if (lang) {
            var translateFrame = document.querySelector(".goog-te-combo");
            if (translateFrame) {
                translateFrame.value = lang;
                translateFrame.dispatchEvent(new Event("change"));
            }
        }
    }

    return (
        <div className='select-lang'>
            <select onChange={changeLang} defaultValue="" translate="no">
                <option value="" disabled>Language</option>
                <option value='en'>English</option>
                <option value='hi'>Hindi</option>
                <option value='bho'>Bhojpuri</option>
                <option value='pa'>Punjabi</option>
                <option value='mr'>Marathi</option>
                <option value='te'>Telugu</option>
                <option value='ta'>Tamil</option>
                <option value='kn'>Kannada</option>
                <option value='gu'>Gujarati</option>
                <option value='ur'>Urdu</option>
            </select>
        </div>
    )

}

export default TranslateBox;